import {
	THEME_CLOSE_MOBILE_SIDEBAR,
	THEME_OPEN_MOBILE_SIDEBAR,
	THEME_SET_BIG_SIDEBAR_SIZE,
	THEME_SET_DARK,
	THEME_SET_DESKTOP_VERSION,
	THEME_SET_LIGHT,
	THEME_SET_MOBILE_VERSION,
	THEME_SET_SMALL_SIDEBAR_SIZE,
	THEME_TOGGLE,
	THEME_TOGGLE_MOBILE_SIDEBAR,
	THEME_TOGGLE_SIDEBAR_SIZE
} from './constants';

export const toggleTheme = () => ({type: THEME_TOGGLE});
export const setDarkTheme = () => ({type: THEME_SET_DARK});
export const setLightTheme = () => ({type: THEME_SET_LIGHT});

export const activeThemeDesktopVersion = () => ({type: THEME_SET_DESKTOP_VERSION});
export const activeThemeMobileVersion = () => ({type: THEME_SET_MOBILE_VERSION});

export const openMobileSidebar = () => ({type: THEME_OPEN_MOBILE_SIDEBAR});
export const closeMobileSidebar = () => ({type: THEME_CLOSE_MOBILE_SIDEBAR});
export const toggleMobileSidebar = () => ({type: THEME_TOGGLE_MOBILE_SIDEBAR});

export const toggleDesktopSidebarSize = () => ({type: THEME_TOGGLE_SIDEBAR_SIZE});
export const setDesktopSmallSidebarSize = () => ({type: THEME_SET_SMALL_SIDEBAR_SIZE});
export const setDesktopBigSidebarSize = () => ({type: THEME_SET_BIG_SIDEBAR_SIZE});
